import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function HotSection() {
  const hot = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 3);
  const grid = articles.slice(4, 8);

  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
            <i className="ri-fire-line" aria-hidden="true"></i>
            TRENDING
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门爆料排行
          </h2>
        </div>
        <Link
          to="/topics"
          className="flex items-center gap-1 font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
        >
          查看更多
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <ol className="rounded-lg border border-background-200 bg-secondary-50 p-5 md:p-6">
            {hot.map((article, index) => (
              <li key={article.id} className="border-b border-secondary-200 py-4 first:pt-0 last:border-b-0 last:pb-0">
                <Link to={`/article/${article.id}`} className="group flex items-start gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {index + 1}
                  </span>
                  <span className="flex flex-col">
                    <span className="font-heading text-sm font-semibold leading-relaxed text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                      {article.title}
                    </span>
                    <span className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                      <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                      热度 {article.heat}
                      <span aria-hidden="true">·</span>
                      {article.readMinutes} 分钟
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-7">
          {grid.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}